import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import IconButton from "../../../../../components/IconButton";
import PlayButton from "../../../../../components/buttons/PlayButton";
import { validateAppointmentType } from "../../../../../services-logic/calendar-management/calendar-management-logic";
import AccordionHeader from "../../../../common-components/AccordionHeader";
import { durationToText } from "./accordion-body-components/DurationDropdown";

const AppointmentTypesAccordionHeader = forwardRef(({ item, index, isActive, onRemoveAppointmentType }, ref) => {
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const { appointmentTypeErrors, config } = useSelector((state) => state.calendarManagement);
  const voices = useSelector((state) => state.info.voices);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);

  const generateTextToPlay = (item) => {
    if (!validateAppointmentType(index, item).valid) {
      return "";
    }

    if (selectedVoice?.enablePreview === false) {
      return "";
    }

    var hour = Math.floor(item.duration / 60);
    var minutes = item.duration % 60;
    var durationText = hour == 0 ? "" : hour == 1 ? hour + " hour" : hour + " hours";
    durationText += hour > 0 && minutes > 0 ? " and " + minutes + " minutes" : minutes > 0 ? minutes + " minutes" : "";

    if (item.duration === 90) {
      durationText = "an hour and a half";
    }

    var ttsText = `${item.type} typically takes ${durationText}. ${item.description}`;
    return ttsText;
  };

  const validationMessage = () => {
    if (
      !appointmentTypeErrors[index] ||
      Object.keys(appointmentTypeErrors[index]).length === 0 ||
      Object.keys(appointmentTypeErrors[index]).every((key) => appointmentTypeErrors[index][key] === "")
    ) {
      return "";
    }

    const validation = validateAppointmentType(index, item);
    if (!validation.valid) {
      return "Required fields missing.";
    }
    return "";
  };

  return (
    <AccordionHeader
      ref={ref}
      prefixIcon={"/assets/icons/common/appointment.svg"}
      title={`${item.type}`}
      subtitle={item.type && durationToText(item.duration)}
      isActive={isActive}
      validationMessage={validationMessage()}
      actionsChildren={
        <div className="flex gap-2 justify-center items-center">
          <PlayButton
            voice={selectedVoice?.id}
            id={`appointment-type-${index}`}
            text={generateTextToPlay(item)}
            iconSize="size-5"
            preventPropagation={isActive}
          />
          <IconButton
            iconSize="size-5"
            icon={"/assets/icons/actions/delete.svg"}
            hoverIcon={"/assets/icons/actions/delete-hover.svg"}
            onClick={(event) => {
              event?.stopPropagation();
              onRemoveAppointmentType(index);
            }}
          />
        </div>
      }
    />
  );
});

export default AppointmentTypesAccordionHeader;
